<div class="px-px-24  py-px-1" style="background: #F3F8FA;" [formGroup]="formFilter">
  <div class="d-flex align-items-center gap-3 my-3 mission-toolbar">
    <div class="inner-add-on left-add-on mission-search">
      <input type="search" class="form-control w-100"
             formControlName="missionTitle"
             placeholder="Recherche par référence"/>
      <svg-icon class="inner-icon left" svgClass="placeholder-icon" src="/assets/icons/search-grey.svg"></svg-icon>
    </div>
    <mat-form-field appearance="outline" class="w-fit-content d-flex align-items-center mission-status">
      <mat-label class="fs-16 fw-6">
        <svg-icon src="/assets/icons/filter.svg"></svg-icon>
        Statut mission
      </mat-label>
      <mat-select multiple formControlName="missionStatus">
        @for (item of filterList;track item) {
          <mat-option [value]="item?.value">
            {{ item?.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <app-custom-datepicker class="mission-date" [parentForm]="formFilter" controlName="activeOnDate"
                           placeholder="Filtrer par date"
                           innerClass="date-filter-field"
                           [readonly]="true" [clearable]="true"
                           [required]="false"></app-custom-datepicker>
    <div class="create-mission-btn" *appHasPermission="'MISSION_WRITE'">
      <app-button text="Créer une mission" (click)="goTo()" innerClass="p-3"
                  iconSide="left" srcIcon="/assets/icons/plus.svg"></app-button>
    </div>
  </div>

  <div class="card-container p-px-8 quick-filter-etablissements" *ngIf="siteList.length">
    @for (item of siteList;track item.id) {
      <app-filter-tag [text]="item.name" bgColor="white" color="white"
                      [chipSelected]="addressId === item.id"
                      (handleClick)="toggleSelectSite($event, item)"></app-filter-tag>
    }

  </div>
  <!--                <div *ngIf="isLoading" class="loader-overlay">-->
  <!--                  <app-loader></app-loader>-->
  <!--                </div>-->
  <app-data-table
    [isLoading]="isLoading"
    [dataSource]="missionList"
    [columns]="customColumns"
    (onFullRowClick)="handleRowClick($event)"
    [hasRowAction]="true"
    [showSideBar]="true"
    [component]="component"
    [totalItems]="totalItems"
    (nextPage)="pagination($event)"
    [pageSize]="size"
    [pageIndex]="formFilter.get('page')?.value || 0"
  ></app-data-table>
</div>


